import { Card, CardContent } from '@/components/ui/card';
import { Star } from 'lucide-react';

export const LandingTestimonials = ({ testimonials }) => {
  if (testimonials.length === 0) return null;

  return (
    <section className="py-16 md:py-20" data-testid="landing-testimonials">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-900 mb-4">Depoimentos</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map(t => (
            <Card key={t.validation_id} className="bg-white border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
              <CardContent className="pt-6">
                <div className="flex items-center gap-3 mb-3">
                  {t.user_picture ? (
                    <img src={t.user_picture} alt="" className="w-10 h-10 rounded-full object-cover" />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-slate-200 flex items-center justify-center">
                      <span className="text-slate-500 font-bold text-sm">{(t.user_name || 'U')[0]}</span>
                    </div>
                  )}
                  <div>
                    <p className="font-semibold text-slate-900 text-sm">{t.user_name || 'Usuario'}</p>
                    <div className="flex gap-0.5">{[1,2,3,4,5].map(s => <Star key={s} className={`h-3.5 w-3.5 ${s <= t.rating ? 'fill-amber-400 text-amber-400' : 'text-slate-200'}`} />)}</div>
                  </div>
                </div>
                <p className="text-slate-700 text-sm">"{t.testimonial}"</p>
                <p className="text-xs text-slate-400 mt-3">{new Date(t.validated_at).toLocaleDateString('pt-BR')}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
